import React, { useEffect, useState } from 'react';
import { apiServices } from '../utils/apiServices';
import { ISubnetResponse } from '../utils/types';
import SubnetsTable from '../components/SubnetsTable';

const Subnets: React.FC = () => {
  const [subnets, setSubnets] = useState<ISubnetResponse[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchSubnets = async () => {
      setLoading(true);
      setError(null);
      try {
        const subnetsData = await apiServices.price.subnets();
        setSubnets(subnetsData);
      } catch (err) {
        console.error('Failed to fetch subnets:', err);
        setError(err instanceof Error ? err.message : 'Failed to fetch subnets');
        setSubnets([]);
      } finally {
        setLoading(false);
      }
    };
    fetchSubnets();
  }, []);

  return (
    <div className="min-h-screen p-4 sm:p-6 lg:p-8">
      <div className="max-w-7xl mx-auto">
        {error && (
          <div className="mb-4 p-4 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg">
            <p className="text-red-600 dark:text-red-400">{error}</p>
          </div>
        )}
        
        <SubnetsTable subnets={subnets} loading={loading} />
      </div>
    </div>
  );
};

export default Subnets;